import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
import "./Style.css";
import { Form, Button, Image } from "react-bootstrap";
import AutoTranslate from "../../Components/AutoTranslate";

const AniFormGroup = ({
  formGroupClassName = "",
  formLabelClassName = "",
  formControlClassName = "",
  type = "text",
  inputMode = undefined,
  name = "",
  step = 0,
  activeStep = 0,
  title = "",
  placeholder = "",
  value = "",
  idCheck = "",
  passwordCheck = "",
  companyCodeCheck = "",
  smsSend = "",
  smsCheck = "",
  items = [],
  onChange = () => {},
  onKeyUp = () => {},
  onClick = () => {},
  onCheck = () => {},
  onTimerComplete = () => {},
  companySmsSend = "",
  companySmsCheck = "",
  onReset = () => {},
  warningText = "",
  showActionButton = true,
  disableAutoFocus = false,
}) => {
  const language = useSelector((state) => state.localStorage.language);
  const inputRef = useRef(null);
  const selectRef = useRef(null);
  const [timer, setTimer] = useState(300);
  const timerRef = useRef(null);
  const [wording, setWording] = useState({
    idCheckMessage1: "아이디는 영문과 숫자만 사용하여 5자리 이상이어야 합니다.",
    idCheckMessage2: "사용가능한 아이디입니다.",
    idCheckMessage3: "이미 사용 중인 아이디입니다.",
    companyCodeCheckMessage1: "올바른 사업자 등록번호 형식이 아닙니다. (예: 000-00-00000)",
    companyCodeCheckMessage2: "사업자 등록번호가 확인되었습니다.",
    companyCodeCheckMessage3: "사업자 등록번호가 잘못되었거나 이미 등록된 번호입니다.",
    passwordCheckMessage1: "비밀번호는 영문과 숫자를 포함하여 8자리 이상이어야 합니다.",
    passwordCheckMessage2: "비밀번호가 일치합니다.",
    passwordCheckMessage3: "비밀번호가 일치하지 않습니다.",
    smsSendMessage1: "인증번호가 전송되었습니다.",
    smsSendMessage2: "인증번호 전송",
    smsCheckMessage1: "인증번호가 확인되었습니다.",
    smsCheckMessage2: "인증번호를 다시 확인해주세요.",
    smsCheckMessage3: "인증번호 확인",
  });

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    const _idCheckMessage1 = await TranslationService.translateText(wording.idCheckMessage1, language.lang);
    const _idCheckMessage2 = await TranslationService.translateText(wording.idCheckMessage2, language.lang);
    const _idCheckMessage3 = await TranslationService.translateText(wording.idCheckMessage3, language.lang);
    const _companyCodeCheckMessage1 = await TranslationService.translateText(wording.companyCodeCheckMessage1, language.lang);
    const _companyCodeCheckMessage2 = await TranslationService.translateText(wording.companyCodeCheckMessage2, language.lang);
    const _companyCodeCheckMessage3 = await TranslationService.translateText(wording.companyCodeCheckMessage3, language.lang);
    const _passwordCheckMessage1 = await TranslationService.translateText(wording.passwordCheckMessage1, language.lang);
    const _passwordCheckMessage2 = await TranslationService.translateText(wording.passwordCheckMessage2, language.lang);
    const _passwordCheckMessage3 = await TranslationService.translateText(wording.passwordCheckMessage3, language.lang);
    const _smsSendMessage1 = await TranslationService.translateText(wording.smsSendMessage1, language.lang);
    const _smsSendMessage2 = await TranslationService.translateText(wording.smsSendMessage2, language.lang);
    const _smsCheckMessage1 = await TranslationService.translateText(wording.smsCheckMessage1, language.lang);
    const _smsCheckMessage2 = await TranslationService.translateText(wording.smsCheckMessage2, language.lang);
    const _smsCheckMessage3 = await TranslationService.translateText(wording.smsCheckMessage3, language.lang);
    setWording({
      ...wording,
      idCheckMessage1: _idCheckMessage1,
      idCheckMessage2: _idCheckMessage2,
      idCheckMessage3: _idCheckMessage3,
      companyCodeCheckMessage1: _companyCodeCheckMessage1,
      companyCodeCheckMessage2: _companyCodeCheckMessage2,
      companyCodeCheckMessage3: _companyCodeCheckMessage3,
      passwordCheckMessage1: _passwordCheckMessage1,
      passwordCheckMessage2: _passwordCheckMessage2,
      passwordCheckMessage3: _passwordCheckMessage3,
      smsSendMessage1: _smsSendMessage1,
      smsSendMessage2: _smsSendMessage2,
      smsCheckMessage1: _smsCheckMessage1,
      smsCheckMessage2: _smsCheckMessage2,
      smsCheckMessage3: _smsCheckMessage3,
    });
  };
  const [translatedPlaceholder, setTranslatedPlaceholder] = useState(placeholder);

  const isActiveStep = activeStep === step;

  useEffect(() => {
    // wizard 모드(disableAutoFocus)에서는 iOS 호환을 위해 programmatic focus 생략
    // iOS는 사용자 제스처 체인 외부의 focus() 호출을 무시하여 키보드가 열리지 않음
    if (!isActiveStep || disableAutoFocus) return;

    let timerId = null;
    const frameId = requestAnimationFrame(() => {
      timerId = setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
    });

    return () => {
      cancelAnimationFrame(frameId);
      if (timerId) clearTimeout(timerId);
    };
  }, [activeStep, step, isActiveStep, disableAutoFocus]);

  useEffect(() => {
    if (type === "select-nationality" && selectRef.current) {
      const select = selectRef.current;

      const updateFlag = () => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.flag) {
          select.style.setProperty("--selected-flag", `url(${selectedOption.dataset.flag})`);
        } else {
          select.style.removeProperty("--selected-flag");
        }
      };

      updateFlag();
      select.addEventListener("change", updateFlag);

      return () => {
        select.removeEventListener("change", updateFlag);
      };
    }
  }, [type, value]);

  useEffect(() => {
    // 타이머 시작 조건
    const shouldStartTimer = (name === "smsCode" && smsSend === true && smsCheck !== true) || (name === "companySmsCode" && companySmsSend === true && companySmsCheck !== true);
    const shouldStopTimer = (name === "smsCode" && smsCheck === true) || (name === "companySmsCode" && companySmsCheck === true);

    // 타이머 시작
    if (shouldStartTimer) {
      timerRef.current = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(timerRef.current);
            // 각 타입별 체크 상태 확인
            const isNotCompleted = (name === "smsCode" && smsCheck !== true) || (name === "companySmsCode" && companySmsCheck !== true);
            if (isNotCompleted) {
              onTimerComplete();
            }
            setTimer(300);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    if (shouldStopTimer) {
      clearInterval(timerRef.current);
      setTimer(300);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [smsSend, smsCheck, companySmsSend, companySmsCheck]);

  useEffect(() => {
    const translatePlaceholder = async () => {
      if (language.lang === "ko") {
        setTranslatedPlaceholder(placeholder);
        return;
      }

      try {
        const _placeholder = await TranslationService.translateText(placeholder, language.lang);
        setTranslatedPlaceholder(_placeholder);
      } catch (error) {
        console.error("Placeholder translation error:", error);
        setTranslatedPlaceholder(placeholder);
      }
    };

    translatePlaceholder();
  }, [placeholder, language.lang]);

  const getEnterKeyHint = () => {
    // "next"는 Android에서 DOM 탭 순서상 다음 입력으로 포커스를 강제 이동시킴 → "go" 사용
    if (name === "email") return "done";
    return "go";
  };

  const handleEnterKey = (e) => {
    const isEnter = e.key === "Enter" || e.keyCode === 13;
    if (!isEnter) return;
    e.preventDefault();
    e.stopPropagation();
    onKeyUp(e, e.target.value);
  };

  const RenderFormControl = () => {
    return (
      <Form.Control
        className={formControlClassName}
        ref={inputRef}
        type={type}
        inputMode={inputMode}
        name={name}
        placeholder={translatedPlaceholder}
        value={value}
        enterKeyHint={getEnterKeyHint()}
        tabIndex={isActiveStep ? 0 : -1}
        autoComplete='off'
        onChange={onChange}
        onKeyDown={handleEnterKey}
        onClick={(e) => onClick(e, name)}
        disabled={
          (name === "smsCode" && smsCheck === true) ||
          (name === "companySmsCode" && companySmsCheck === true) ||
          (name === "phone" && smsCheck === true) ||
          (name === "companyPhone" && companySmsCheck === true) ||
          (name === "companyCode" && companyCodeCheck === true) ||
          (name === "password" && passwordCheck === true) ||
          (name === "passwordConfirm" && passwordCheck === true)
        }
      />
    );
  };

  const RenderValidationButton = () => {
    // RenderValidationButton에서 name 조건을 확장
    if (name !== "id" && name !== "password" && name !== "passwordConfirm" && name !== "companyCode" && name !== "phone" && name !== "smsCode" && name !== "companyPhone" && name !== "companySmsCode")
      return null;

    const getConfig = () => {
      switch (name) {
        case "id":
          // 영문+숫자 조합 5자리 이상 체크 (영문과 숫자만 허용)
          const idRegex = /^[A-Za-z0-9]{5,}$/;
          const isValidId = idRegex.test(value);

          if (!isValidId) {
            return {
              status: false,
              successMessage: "",
              errorMessage: wording.idCheckMessage1,
              buttonText: "중복확인",
              disabled: true,
            };
          }

          return {
            status: idCheck,
            successMessage: wording.idCheckMessage2,
            errorMessage: wording.idCheckMessage3,
            buttonText: "중복확인",
            disabled: false,
          };
        case "companyCode":
          // 사업자 등록번호 형식 체크 (000-00-00000)
          const companyCodeRegex = /^\d{3}-\d{2}-\d{5}$/;
          const isValidCompanyCode = companyCodeRegex.test(value);

          if (!isValidCompanyCode) {
            return {
              status: false,
              successMessage: "",
              errorMessage: wording.companyCodeCheckMessage1,
              buttonText: "사업자 등록번호 인증",
              disabled: true,
            };
          }

          return {
            status: companyCodeCheck,
            successMessage: wording.companyCodeCheckMessage2,
            errorMessage: wording.companyCodeCheckMessage3,
            buttonText: "사업자 등록번호 인증",
            disabled: false,
          };
        case "password":
          return {
            status: "",
            normalMessage: wording.passwordCheckMessage1,
            successMessage: "",
            errorMessage: "",
            buttonText: "",
            disabled: false,
          };
        case "passwordConfirm":
          return {
            status: passwordCheck,
            successMessage: wording.passwordCheckMessage2,
            errorMessage: wording.passwordCheckMessage3,
            buttonText: "",
            disabled: false,
          };
        case "phone":
          return {
            status: smsSend,
            successMessage: wording.smsSendMessage1,
            errorMessage: "",
            buttonText: wording.smsSendMessage2,
            disabled: smsSend === true,
          };
        case "smsCode":
          return {
            status: smsCheck,
            successMessage: wording.smsCheckMessage1,
            errorMessage: wording.smsCheckMessage2,
            buttonText: wording.smsCheckMessage3,
            disabled: false,
          };
        case "companyPhone":
          return {
            status: companySmsCheck,
            successMessage: wording.smsSendMessage1,
            errorMessage: "",
            buttonText: wording.smsSendMessage2,
            disabled: companySmsSend === true,
          };
        case "companySmsCode":
          return {
            status: companySmsCheck,
            successMessage: wording.smsCheckMessage1,
            errorMessage: wording.smsCheckMessage2,
            buttonText: wording.smsCheckMessage3,
            disabled: false,
          };

        default:
          return null;
      }
    };

    const config = getConfig();
    if (!config) return null;

    const getStatusMessage = () => {
      if (name === "id" && config.status === "") return "중복확인해주세요";
      if (config.status === true) return config.successMessage;
      if (config.status === false) return config.errorMessage;
      if (config.status === "") return config.normalMessage;
      return "";
    };

    return (
      <div className='d-flex justify-content-between mt-2'>
        <span style={{ color: config.status === true ? "#03bbfe" : config.status === false ? "red" : name === "id" && config.status === "" ? "red" : "#000000" }}>{getStatusMessage()}</span>
        <div className='d-flex align-items-center gap-2'>
          {name === "smsCode" && smsSend === true && (
            <span style={{ color: "#03bbfe", fontSize: "1.2rem" }}>
              {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")}
            </span>
          )}
          {name === "companySmsCode" && companySmsSend === true && (
            <span style={{ color: "#03bbfe", fontSize: "1.2rem" }}>
              {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")}
            </span>
          )}
          {name !== "password" && name !== "passwordConfirm" && showActionButton && (
            <Button tabIndex={isActiveStep ? 0 : -1} disabled={config.disabled} onClick={() => onCheck(value, name)}>
              <AutoTranslate targetLanguage={language.lang}>{config.buttonText}</AutoTranslate>
            </Button>
          )}
          {name === "phone" && smsCheck === true && (
            <Button tabIndex={isActiveStep ? 0 : -1} variant='outline-secondary' onClick={() => onReset(name)}>
              <AutoTranslate targetLanguage={language.lang}>전화번호 변경</AutoTranslate>
            </Button>
          )}
          {name === "companyPhone" && companySmsCheck === true && (
            <Button tabIndex={isActiveStep ? 0 : -1} variant='outline-secondary' onClick={() => onReset(name)}>
              <AutoTranslate targetLanguage={language.lang}>전화번호 변경</AutoTranslate>
            </Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <Form.Group className={`${activeStep >= step ? "form-group-animation" : "form-group-hidden"} ${formGroupClassName}`}>
      <Form.Label className={formLabelClassName}>
        <AutoTranslate targetLanguage={language.lang}>{title}</AutoTranslate>
      </Form.Label>
      {RenderFormControl()}
      {warningText && (
        <div className='mt-2' style={{ color: "#dc3545" }}>
          <AutoTranslate targetLanguage={language.lang}>{warningText}</AutoTranslate>
        </div>
      )}
      {RenderValidationButton()}
    </Form.Group>
  );
};

export default AniFormGroup;
